import React from 'react';
import Typography from '@justpark/ui/src/components/Typography';
import FAQs from '@justpark/ui/src/components/FAQs';
import Heading from '@justpark/ui/src/components/Heading';
import { useTranslation } from 'react-i18next';

const faqs = [
  {
    question: 'How does it work?',
    answer: (
      <Typography>
        JustPark has access to tens of thousands of spaces from car parks to
        private driveways that you can book in advance. Once you’ve found a
        space on our App or website, complete your booking and we’ll send
        through details of how to find and use your space.
      </Typography>
    )
  },
  {
    question: 'How can I contact you if I need help?',
    answer: (
      <Typography>
        We have a dedicated customer support team online 8-8 Mon-Fri and 9-6
        Sat-Sun. You can call or Live Chat with them during these hours. Contact
        details can be found on our Help Centre.
      </Typography>
    )
  },
  {
    question: 'How do I find my space?',
    answer: (
      <Typography>
        When you have completed your booking and payment has been taken, we’ll
        send through the exact address and access instructions to your space.
      </Typography>
    )
  },
  {
    question: 'Can I cancel my booking?',
    answer: (
      <Typography>
        Yes we have a flexible cancellation policy, you can cancel up to 24hrs
        before the start time of your booking.
      </Typography>
    )
  }
];

const ListingFAQs = () => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level={2}>
        {t('listingDetails:faqHeader', 'Frequently asked questions')}
      </Heading>
      <FAQs faqs={faqs} />
    </>
  );
};

export default ListingFAQs;
